import { j as e } from "../../jsx-runtime.BREq8dyb.js";
import { usePrevious as E } from "@decentriq/hooks";
import { faCircleXmark as S, faCircleCheck as X } from "@fortawesome/pro-light-svg-icons";
import { faCircleXmark as H, faCircleCheck as Y } from "@fortawesome/pro-thin-svg-icons";
import { FontAwesomeIcon as x } from "@fortawesome/react-fontawesome";
import { styled as p, Box as n, LinearProgress as k, Accordion as w, AccordionSummary as I, accordionSummaryClasses as r, AccordionDetails as $, AccordionGroup as z, accordionDetailsClasses as T, accordionClasses as q, CircularProgress as G } from "@mui/joy";
import { memo as L, forwardRef as V, useRef as u } from "react";
import B from "../DqSpinner/DqSpinner.js";
var J = /* @__PURE__ */ ((t) => (t.Pending = "Pending", t.Fulfilled = "Fulfilled", t.Rejected = "Rejected", t))(J || {});
const F = p(n)({
  "&:not(:empty):not(:last-of-type)": {
    marginRight: "0.5rem"
  },
  display: "inline"
});
F.displayName = "StyledLoadLabel";
const D = L(V(({
  children: t,
  ...d
}, i) => /* @__PURE__ */ e.jsx(n, { ref: i, ...d, children: /* @__PURE__ */ e.jsx("div", { className: "value", children: "%" }) })));
D.displayName = "LoadProgressPercentage";
const N = p(p(D)`
  @property --num {
    inherits: false;
    initial-value: 0;
    syntax: "<integer>";
  }
  transition: --num 1s;
  counter-reset: num var(--num);
`)({
  "&:not(:first-of-type)": {
    "& .value": {
      "&:after": {
        content: '"100%"',
        display: "block",
        height: 0,
        visibility: "hidden"
      },
      "&:before": {
        content: "counter(num)"
      },
      /**
       * NOTE: Using `fontFeatureSettings` and `fontVariantNumeric`
       * to force equal width for digits https://twitter.com/stackblitz/status/1745063227124261004
       */
      display: "inline",
      fontFeatureSettings: '"tnum"',
      fontSize: "0.75rem",
      fontVariantNumeric: "tabular-nums"
    }
  },
  alignSelf: "flex-end",
  display: "inline-flex",
  textAlign: "right"
});
N.displayName = "StyledLoadProgressPercentage";
const M = L(({
  loadKey: t,
  loadLabel: d,
  loadProgress: i,
  loadResult: s,
  loadResults: g = [],
  loadState: l,
  LoadProgressBarAndLabelAndProgressPercentageProps: j,
  LoadProgressBarProps: o,
  LoadLabelAndProgressPercentageProps: y,
  LoadLabelProps: R,
  LoadProgressPercentageProps: v
}) => {
  const f = E(i), h = u(null), a = u(null), b = u(0);
  return i !== void 0 && f !== void 0 && i < f && b.current++, /* @__PURE__ */ e.jsxs(n, { sx: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: "0.5rem",
    justifyContent: "center",
    overflow: "hidden",
    padding: "0.5rem",
    width: "100%"
  }, children: [
    l === "Pending" ? /* @__PURE__ */ e.jsx(B, { style: {
      height: "8rem",
      width: "8rem"
    } }) : l === "Rejected" ? /* @__PURE__ */ e.jsx(n, { sx: {
      color: "danger.500",
      display: "flex"
    }, children: /* @__PURE__ */ e.jsx(x, { fixedWidth: !0, icon: H, style: {
      height: "5.25rem",
      padding: "1.375rem",
      width: "5.25rem"
    } }) }) : l === "Fulfilled" ? /* @__PURE__ */ e.jsx(n, { sx: {
      color: "success.500",
      display: "flex"
    }, children: /* @__PURE__ */ e.jsx(x, { fixedWidth: !0, icon: Y, style: {
      height: "5.25rem",
      padding: "1.375rem",
      width: "5.25rem"
    } }) }) : null,
    /* @__PURE__ */ e.jsxs(n, { sx: {
      alignItems: "safe center",
      // https://stackoverflow.com/a/33455342
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      overflow: "hidden",
      width: "100%"
    }, children: [
      /* @__PURE__ */ e.jsxs(n, {
        sx: {
          display: "flex",
          flexDirection: "column",
          fontWeight: 500,
          gap: "0.5rem",
          maxWidth: "100%",
          ...j?.sx
        },
        ...j,
        /* Force render with `key` swap to prevent the 100→0 animation on steps change */
        children: [
          i === void 0 ? l === "Fulfilled" || l === "Rejected" ? /* @__PURE__ */ e.jsx(n, { height: 4, width: "100%", ...o }) : /* @__PURE__ */ e.jsx(k, { determinate: !1, sx: {
            "--LinearProgress-thickness": "4px",
            ...o?.sx
          }, ...o }, t || "indeterminate") : /* @__PURE__ */ e.jsx(k, { determinate: !!i, sx: {
            "--LinearProgress-thickness": "4px",
            ...o?.sx
          }, value: i, ...o }, t || `determinate-${b.current}`),
          /* @__PURE__ */ e.jsxs(w, { children: [
            /* @__PURE__ */ e.jsx(I, { slotProps: {
              button: {
                tabIndex: s ? void 0 : -1
              }
            }, sx: {
              "&:only-child": {
                [`& .${r.button}`]: {
                  cursor: "default",
                  pointerEvents: "none"
                },
                [`& .${r.indicator}`]: {
                  display: "none"
                }
              },
              [`& .${r.button}`]: {
                "&:active": {
                  backgroundColor: "transparent !important"
                },
                "&:hover": {
                  backgroundColor: "transparent !important"
                },
                flex: "0 0 auto",
                gap: "0.25rem",
                justifyContent: "center"
              },
              justifyContent: "center"
            }, children: /* @__PURE__ */ e.jsxs(n, { sx: {
              display: "inline",
              fontWeight: 500,
              textAlign: "center",
              ...y?.sx
            }, ...y, children: [
              d ? /* @__PURE__ */ e.jsx(F, { ...R, ref: h, children: d }) : null,
              /* Render nothing if progress jumps to 100 immediately (e.g. single chunk, etc.) */
              f === void 0 && i === 100 ? null : i !== void 0 ? /* @__PURE__ */ e.jsx(N, { ...v, ref: a, style: {
                "--num": i.toFixed(0),
                textAlign: h?.current && a?.current && a?.current.offsetTop > h?.current.offsetTop + a?.current.offsetHeight ? "left" : "right",
                ...v?.style
              } }) : null
            ] }) }),
            s ? /* @__PURE__ */ e.jsx($, { children: s instanceof Error ? s?.message : s }) : null
          ] })
        ]
      }),
      g.filter(Boolean).length > 0 ? /* @__PURE__ */ e.jsx(n, { sx: {
        overflow: "auto",
        p: 1
      }, children: /* @__PURE__ */ e.jsx(z, { disableDivider: !0, sx: {
        "--ListItem-minHeight": "auto",
        "--ListItem-paddingX": "var(--ListItem-paddingY, 0.25rem)",
        "--ListItem-paddingY": "0.5rem"
      }, children: g.filter(Boolean).map(({
        label: W,
        result: c,
        state: C
      }, A) => {
        let m = null;
        switch (C) {
          case "Pending":
            m = /* @__PURE__ */ e.jsx(G, { style: {
              height: "1rem",
              width: "1rem"
            }, sx: {
              height: "1rem",
              width: "1rem"
            }, thickness: 3 });
            break;
          case "Fulfilled":
            m = /* @__PURE__ */ e.jsx(n, { sx: {
              color: "success.500"
            }, children: /* @__PURE__ */ e.jsx(x, { icon: X }) });
            break;
          case "Rejected":
            m = /* @__PURE__ */ e.jsx(n, { sx: {
              color: "danger.500"
            }, children: /* @__PURE__ */ e.jsx(x, { icon: S }) });
            break;
        }
        return /* @__PURE__ */ e.jsxs(w, { disabled: C === "Pending", expanded: !0, children: [
          /* @__PURE__ */ e.jsxs(I, { slotProps: {
            button: {
              tabIndex: c ? void 0 : -1
            }
          }, sx: {
            "&:only-child": {
              [`& .${r.button}`]: {
                cursor: "default",
                pointerEvents: "none"
              },
              [`& .${r.indicator}`]: {
                display: "none"
              }
            },
            [`& .${r.button}`]: {
              alignItems: "flex-start",
              gap: "0.5rem",
              justifyContent: "flex-start"
            },
            [`& .${r.indicator}`]: {
              alignItems: "center",
              display: "flex",
              height: "1.25rem",
              order: 0
            }
          }, children: [
            /* @__PURE__ */ e.jsx(n, { component: "span", sx: {
              fontSize: "0.875rem",
              fontWeight: 500,
              lineHeight: "1.25rem",
              order: 1
            }, children: W }),
            /* @__PURE__ */ e.jsx(n, { component: "span", sx: {
              alignItems: "center",
              display: "inline-flex",
              flex: 1,
              height: "1.25rem",
              justifyContent: "flex-end",
              order: 2
            }, children: m })
          ] }),
          c ? /* @__PURE__ */ e.jsx($, { sx: {
            [`& .${T.content}.${q.expanded}`]: {
              paddingBlock: "var(--ListItem-paddingY)"
            }
          }, children: c instanceof Error ? c?.message : c }) : null
        ] }, A);
      }) }) }) : null
    ] })
  ] });
});
M.displayName = "Loader";
export {
  J as PromiseState,
  M as default
};
//# sourceMappingURL=Loader.js.map
